// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1Oohj","footer":"ReportModalFilter_footer__1Xe4s"};